<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
          type="primary"
          plain
          size="mini"
          icon="el-icon-circle-plus-outline"
          @click="add()"
        >
          新增题库
        </el-button>
        <el-button
          type="danger"
          plain
          size="mini"
          icon="el-icon-circle-close"
          @click="delBath"
          :disabled="ids.length == 0 ? true : false"
          >删除</el-button
        >
      </div>
      <div class="search_box">
        <!-- <el-select v-model="requestData.questionBankType" placeholder="请选择" size="mini" clearable>
          <el-option
            label="选择题"
            :value="1"
          >
          </el-option>
          <el-option
            label="判断题"
            :value="3"
          >
          </el-option>
        </el-select> -->
        <el-input
          v-model.trim="requestData.questionBankName"
          size="mini"
          placeholder="请输入题库名称"
        ></el-input>
        <el-button
          size="mini"
          type="primary"
          plain
          icon="el-icon-search"
          @click="searchData"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="responseData.list"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          v-loading="loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="36"></el-table-column>
          <el-table-column label="序号" width="70" align="center">
            <template v-slot="scope">
              {{
                requestData.pageSize * (requestData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="questionBankName"
            label="题库名称"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- <el-table-column
            label="题库类型"
            align="center"
            show-overflow-tooltip
          >
            <template v-slot="scope">
              <div v-if="scope.row.questionType == 1">选择题</div>
              <div v-if="scope.row.questionType == 2"></div>
              <div v-if="scope.row.questionType == 3">判断题</div>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="questionTime"
            label="题库考核时长"
            width="120"
            align="center"
          >
            <template v-slot="scope">
              {{ scope.row.questionTime }} 分钟
            </template>
          </el-table-column>
          <el-table-column
            prop="numberExercises"
            label="试题数量"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="questionFounder" label="创建人" align="center" width="200">
          </el-table-column>
          <el-table-column
            prop="addTime"
            label="创建时间"
            width="160"
            align="center"
          >
            <template v-slot="scope">
              {{ $Common.dateFormatDateTwo(scope.row.addTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template v-slot="scope">
              <el-link
                type="primary"
                @click="edit(scope.row)"
                :underline="false"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-dropdown>
                <span class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="dropdown_item_box"
                    ><el-link
                      class="link_box"
                      type="primary"
                      @click="check(scope.row)"
                      :disabled="scope.row.numberExercises == 0 ? true : false"
                      :underline="false"
                      >考核</el-link
                    ></el-dropdown-item
                  >
                  <el-dropdown-item class="dropdown_item_box"
                    ><el-link
                      class="link_box"
                      type="primary"
                      @click="del(scope.row.questionBankId)"
                      :underline="false"
                      >删除</el-link
                    ></el-dropdown-item
                  >
                  <el-dropdown-item class="dropdown_item_box"
                    ><el-link
                      class="link_box"
                      type="primary"
                      @click="sel(scope.row)"
                      :underline="false"
                      >进入题库</el-link
                    ></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="responseData.total"
        >
        </el-pagination>
      </div>
    </div>
    <question-bank-add
      :addResize="addResize"
      @getList="getList"
    ></question-bank-add>
    <question-bank-edit
      :editResize="editResize"
      :questionBank="questionBank"
      @getList="getList"
    ></question-bank-edit>
    <question-bank-qr
      :qrResize="qrResize"
      :questionOrder="questionOrder"
      :type="type"
    ></question-bank-qr>
    <question-bank-check
      :checkResize="checkResize"
      :questionOrder="questionOrder"
      :type="type"
    ></question-bank-check>
    <el-dialog title="选择考核方式" :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false" width="240px">
      <div style="padding: 20px;">
        <el-button type="primary" @click="selType(1)">电脑端</el-button>
        <el-button type="primary" @click="selType(2)">手机端</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import vueQr from "vue-qr";
import QuestionBankAdd from "./components/QuestionBankAdd";
import QuestionBankEdit from "./components/QuestionBankEdit";
import QuestionBankQr from "./components/QuestionBankQr";
import QuestionBankCheck from "./components/QuestionBankCheck";
export default {
  name: "",
  components: {
    vueQr,
    QuestionBankAdd,
    QuestionBankEdit,
    QuestionBankQr,
    QuestionBankCheck
  },
  props: {},
  data() {
    return {
      dialogVisible: false,
      requestData: {
        schoolId: this.$store.state.schoolId,
        pageSize: 20,
        pageNum: 1,
        questionBankName: ""
        // questionBankType: ""
      },
      responseData: {
        pageSize: 20,
        pageNum: 1,
        total: 0,
        pages: 1,
        list: []
      },
      ids: [],
      loading: false,
      type: 0,
      addResize: 0,
      qrResize: 0,
      questionBankId: 0,
      checkResize: 0,
      questionOrder: 0,
      editResize: 0,
      questionBank: {}
    };
  },
  created() {
    this.getList();
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      console.log(`当前页: ${val}`);
      this.getList();
    },
    handleSelectionChange(val) {
      this.ids = val.map((element) => {
        return element.questionBankId;
      });
    },
    add() {
      this.addResize++;
    },
    edit(row) {
      this.questionBank = row;
      this.editResize++;
    },
    check(row) {
      this.type = row.questionType;
      this.questionOrder = row.questionBankId;
      this.dialogVisible = true;
    },
    selType(num) {
      if (num == 1) {
        this.$confirm("确定要开始考核吗？", {
          type: "warning"
        })
          .then(async () => {
            this.dialogVisible = false;
            this.checkResize++;
          })
          .catch(() => {});
      } else {
        this.dialogVisible = false;
        this.qrResize++;
      }
    },
    sel(row) {
      this.$router.push({
        path: "/SafetyPaper",
        query: {
          id: row.questionBankId
        }
      });
    },
    searchData() {
      this.requestData.pageNum = 1;
      this.getList();
    },
    async getList() {
      let req = this.requestData;
      this.loading = true;
      let res = await this.$Http.getQuestionBank(req);
      this.loading = false;
      if (res.code == 200) {
        this.responseData = res.data;
      } else if (res.code == 101) {
        this.responseData = {
          pageSize: 20,
          pageNum: 1,
          total: 0,
          pages: 1,
          list: []
        };
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    del(id) {
      this.$confirm("确定要删除此题目吗？", {
        type: "warning"
      })
        .then(() => {
          this.delQuestionBank([id]);
        })
        .catch(() => {});
    },
    delBath() {
      this.$confirm("确定要删除选中题目吗？", {
        type: "warning"
      })
        .then(() => {
          this.delQuestionBank(this.ids);
        })
        .catch(() => {});
    },
    async delQuestionBank(list) {
      let req = {
        questionBankIdList: list
      };
      let res = await this.$Http.delQuestionBank(req);
      if (res.code == 200) {
        this.getList();
        this.$message({
          type: "success",
          message: "删除成功"
        });
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
